import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-27897a94"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ido" }
const _hoisted_2 = { class: "ido__elm" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ido__elm-header-text" }, "Покупка опций", -1))
const _hoisted_4 = {
  key: 0,
  class: "ido__elm-body"
}
const _hoisted_5 = {
  key: 0,
  class: "ido__elm-body-item"
}
const _hoisted_6 = { class: "ido__elm-body-item-checkbox" }
const _hoisted_7 = { class: "ido__elm-body-item-text" }
const _hoisted_8 = { class: "ido__elm-body-item-text" }
const _hoisted_9 = {
  key: 0,
  class: "ido__elm-body-line"
}
const _hoisted_10 = {
  key: 1,
  class: "ido__elm-body-expired"
}
const _hoisted_11 = { class: "ido__elm-body-expired-info" }
const _hoisted_12 = { class: "ido__elm-body-expired-info-item" }
const _hoisted_13 = { class: "ido__elm-body-expired-info-item" }
const _hoisted_14 = { class: "ido__elm-body-expired-info-item" }
const _hoisted_15 = {
  key: 0,
  class: "ido__elm-body-expired-info-item_option"
}
const _hoisted_16 = { class: "ido__elm-body-expired-info-item_option" }
const _hoisted_17 = {
  key: 2,
  class: "ido__elm-body-item"
}
const _hoisted_18 = { class: "ido__elm-body-item-checkbox" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ido__elm-body-item-text" }, " Хочу продлить на месяц. ", -1))
const _hoisted_20 = {
  key: 1,
  class: "ido__elm-footer"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IconChevronDown = _resolveComponent("IconChevronDown")!
  const _component_UiSwitcher = _resolveComponent("UiSwitcher")!
  const _component_UiButton = _resolveComponent("UiButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onClickShowOptions && _ctx.onClickShowOptions(...args))),
        class: "ido__elm-header"
      }, [
        _hoisted_3,
        _createElementVNode("div", {
          class: _normalizeClass(
						_ctx.isShowOptions
							? 'ido__elm-header-icon-down'
							: 'ido__elm-header-icon-up'
					)
        }, [
          _createVNode(_component_IconChevronDown)
        ], 2)
      ]),
      (_ctx.isShowOptions)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.optionList, (item, index) => {
              return (_openBlock(), _createElementBlock("div", { key: index }, [
                (_ctx.excludePaid(item.id))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                      _createElementVNode("div", _hoisted_6, [
                        _createVNode(_component_UiSwitcher, {
                          "is-array-items": true,
                          name: `${item.name}`,
                          "item-id": Number(item.id),
                          onCheckedItem: _ctx.checked
                        }, null, 8, ["name", "item-id", "onCheckedItem"])
                      ]),
                      _createElementVNode("div", _hoisted_7, _toDisplayString(item.name), 1),
                      _createElementVNode("div", _hoisted_8, _toDisplayString(item.cost) + " руб. ", 1)
                    ]))
                  : _createCommentVNode("", true)
              ]))
            }), 128)),
            (_ctx.optionsMap.size !== 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_9))
              : _createCommentVNode("", true),
            (!_ctx.isPayMonthDisable && _ctx.isPayMonthChecked)
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("div", _hoisted_12, " Канал будет продлён до: " + _toDisplayString(_ctx.payInstanceExpired) + ". ", 1),
                    _createElementVNode("div", _hoisted_13, " Расчётный период сместится на: " + _toDisplayString(_ctx.billingPeriod) + " дн. ", 1),
                    _createElementVNode("div", _hoisted_14, " Доплата за канал составит: " + _toDisplayString(Math.round(_ctx.surcharge)) + " руб. ", 1),
                    (_ctx.isPaidOptionsNeedRenew)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_15, " Доплата за опции: "))
                      : _createCommentVNode("", true),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.surchargeOptionList, (item, index) => {
                      return (_openBlock(), _createElementBlock("div", { key: index }, [
                        _createElementVNode("div", _hoisted_16, _toDisplayString(index + 1) + ". " + _toDisplayString(item.name) + ": составит " + _toDisplayString(Math.round(item.cost)) + " руб. ", 1)
                      ]))
                    }), 128))
                  ])
                ]))
              : _createCommentVNode("", true),
            (!_ctx.isPayMonthDisable)
              ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                  _createElementVNode("div", _hoisted_18, [
                    _createVNode(_component_UiSwitcher, {
                      "is-array-items": true,
                      name: "pay_for_month",
                      "item-id": 1,
                      onCheckedItem: _ctx.payMonthChecked,
                      "is-disable": _ctx.isPayMonthDisable,
                      "is-checked": _ctx.isPayMonthChecked
                    }, null, 8, ["onCheckedItem", "is-disable", "is-checked"])
                  ]),
                  _hoisted_19
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      (_ctx.optionsMap.size !== 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
            _createVNode(_component_UiButton, {
              onClick: _ctx.onClickPay,
              label: `Оплатить ${_ctx.payBtnInfo} руб`,
              "background-color": "var(--theme-color)",
              "border-color": "var(--theme-color)",
              color: "rgb(255, 255, 255)"
            }, null, 8, ["onClick", "label"]),
            _withDirectives(_createElementVNode("div", null, _toDisplayString(_ctx.paidOptionsCalculate), 513), [
              [_vShow, false]
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}